import { Component, inject, output, signal, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Container } from "@components/container/container";
import { Header } from "@components/header/header";
import { EDUCATION_LEVEL_GROUPS } from "@config";
import { EducationLevelGroup } from "@domain/EducationLevel";
import { AuthState } from "@states/auth.state";

@Component({
  selector: "app-education-level-selection",
  imports: [Header, RouterModule, Container],
  template: `
    <app-container>
      <app-header (quitExerciser)="quitExerciser.emit()">
        <a class="header__logo-link" [routerLink]="['/']">
          <img class="header__logo-img" src="assets/logo/alloprof.svg" alt="logo" aria-hidden="true" />
        </a>
      </app-header>
      <div class="education-level-selection card card-small">
        <h2 class="education-level-selection__title title-h4">
          Choisis<br />
          ton niveau scolaire
        </h2>
        <ul class="education-level-selection__education-level-list">
          @for (educationLevelGroup of educationLevelGroups; track educationLevelGroup.id) {
            <li class="education-level-selection__education-level">
              <input
                type="radio"
                name="education-level"
                [id]="'education-level-selection__' + educationLevelGroup.id"
                [value]="educationLevelGroup.id"
                class="visuallyhidden"
                [checked]="selectedEducationLevelGroup()?.id === educationLevelGroup.id"
                (change)="this.selectedEducationLevelGroup.set(educationLevelGroup)"
              />
              <label
                [htmlFor]="'education-level-selection__' + educationLevelGroup.id"
                class="btn btn-secondary education-level-selection__selector"
                >{{ educationLevelGroup.name }}</label
              >
            </li>
          }
        </ul>
      </div>
      <button
        type="button"
        [disabled]="!selectedEducationLevelGroup()"
        class="btn btn-primary education-level-selection__confirmation"
        (click)="handleConfirmSelectedEducationLevel()"
      >
        Commencer
      </button>
    </app-container>
  `,
  styles: `
    @use "responsive" as *;

    .header__logo-link {
      margin: 0 auto;
    }

    .header__logo-img {
      display: block;
      width: 110px;
      height: 24px;
    }

    .education-level-selection {
      margin: 0 auto 52px auto;
      padding: 48px 24px 52px 24px;

      @include screenWidth("from-tablet") {
        padding: 48px 80px 60px 80px;
      }
    }

    .education-level-selection__title {
      margin-bottom: 32px;
      text-align: center;
    }

    .education-level-selection__education-level-list {
      list-style-type: none;
      padding: 0;
    }

    .education-level-selection__education-level {
      margin: 0 auto 12px auto;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .education-level-selection__selector {
      width: 100%;
      text-align: center;
    }

    .education-level-selection__confirmation {
      display: block;
      margin: 0 auto;
    }
  `,
})
export class EducationLevelSelection implements OnInit {
  authState = inject(AuthState);
  educationLevelGroups = EDUCATION_LEVEL_GROUPS;

  quitExerciser = output<void>();
  confirmEducationLevelSelection = output<EducationLevelGroup>();

  selectedEducationLevelGroup = signal<EducationLevelGroup | undefined>(undefined);

  ngOnInit() {
    const currentUser = this.authState.currentUser();
    this.selectedEducationLevelGroup.set(currentUser?.educationLevelGroup);
  }

  handleConfirmSelectedEducationLevel() {
    const selectedEducationLevelGroup = this.selectedEducationLevelGroup();

    if (selectedEducationLevelGroup) {
      this.confirmEducationLevelSelection.emit(selectedEducationLevelGroup);
    }
  }
}
